import React from 'react';
import { STATISTICS_TAB_NAME } from '../../enums/statisticsTabName';
import { useTranslation } from '@pascal/pascal-core';

export const StatisticPageButtons = ({ setTabName, tabName }) => {
const t = useTranslation()
return (
    <div className="statistics-tabs-wrp">
      <div className={`stats-tabs ${tabName === STATISTICS_TAB_NAME.Diagram ? 'active' : ''}`}>
        <button onClick={() => setTabName(STATISTICS_TAB_NAME.Diagram)} className={'stats-tabs-btn'}>{t('DIAGRAMS')}</button>
      </div>
      <div className={`stats-tabs ${tabName === STATISTICS_TAB_NAME.PieChart ? 'active' : ''}`}>
        <button onClick={() => setTabName(STATISTICS_TAB_NAME.PieChart)} className={'stats-tabs-btn'}>{t('PIE_CHART')}</button>
      </div>
      <div className={`stats-tabs ${tabName === STATISTICS_TAB_NAME.Numbers ? 'active' : ''}`}>
        <button onClick={() => setTabName(STATISTICS_TAB_NAME.Numbers)} className={'stats-tabs-btn'}>{t('NUMBERS')}</button>
      </div>
    </div>
  )
}